import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Paper } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import Uploader from "src/components/uploader/Uploader";


export default function AgentConfig() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);

  const [form, setForm] = useState({
  });

  useEffect(() => {
    getConfig();
  }, []);

  async function getConfig() {
    const { data } = await asyncRequest({
      method: 'get',
      path: "/agent/config",
    });

    setItems(data);
    const map = {};
    data.forEach((d) => {
      map[d.key] = d.value;
    });
    setForm(map);
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleSubmit() {

    const { msg } = await asyncRequest({
      path: "/agent/config/edit",
      data: {
        form,
      },
    });


    alert(msg, 'success');
  }

  return (
    <Page title="分销配置">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            分销配置
          </Typography>
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          {items.map((item) => {
            const { name, key, desc, inputType } = item;
            if (inputType === 'UPLOAD') {
              return (
                <FormItem labelStyle={{ width: 150 }} title={name} required key={key}>
                  <Stack>
                    <Uploader multiple images={form.promoteBanners} onUploaded={(val) => handleIptChange("promoteBanners", val)} />
                    <Typography mt={2} fontSize={14} color="gray">
                      建议尺寸：750x1334
                    </Typography>
                  </Stack>
                </FormItem>
              )
            }
            return (
              <FormItem labelStyle={{ width: 150 }} title={name} required key={key}>
                <TextField placeholder={desc} autoComplete="off" id={key} value={form[key]} size="small" onChange={(e) => handleIptChange(key, e.target.value)} />
              </FormItem>
            );
          })}

          <FormItem labelStyle={{ width: 150 }}>
            <Button variant="contained" type="submit" onClick={handleSubmit}>
              保存
            </Button>
          </FormItem>
        </Paper>
      </Container>
    </Page>
  );
}
